import { SearchInput } from '../shared';
import { SortOrder, TagSortType } from '../enums';

export class GetTagsInput extends SearchInput<TagSortType> {
    constructor() {
        super(TagSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}